import Image from 'next/image'
import logo from 'assets/dift-full-black.svg'
import { Button } from './Button'

interface CaptainNavProps {
  logoHref?: string | undefined
}

export function CaptainNav({ logoHref = undefined }: CaptainNavProps) {
  return (
    <header
      id="header"
      className="fixed top-0 z-40 flex h-14 w-full flex-wrap items-center justify-start border-b border-inside bg-white px-4 py-3 md:px-10"
    >
      {logoHref ? (
        <Button variant="raw" href={logoHref}>
          <Image src={logo} alt="Dift logo" priority className="h-auto w-16" />
        </Button>
      ) : (
        <Image src={logo} alt="Dift logo" priority className="h-auto w-16" />
      )}
    </header>
  )
}
